export default __webpack_public_path__ + "static/media/Logo.fd977317.svg";